module.exports = __webpack_public_path__ + "img/blanc_1950.e2e6db22.jpg";